module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_6.f2f406ea.png";